export const Questions = [
  {
    question: 'How many cubes are there in a Rubik"s cube?',
    answers: {
      a: "22",
      b: "24",
      c: "26",
      d: "28",
    },
    correctS: "c",
    correctA: "26",
  },
  {
    question: "Which planet in the solar system has the most satellites?",
    answers: {
      a: "Saturn",
      b: "Venus",
      c: "Jupiter",
      d: "Mars",
    },
    correctS: "a",
    correctA: "Saturn",
  },
  {
    question: "What color is the rightmost ring in the Olympic symbols?",
    answers: {
      a: "Blue",
      b: "Yellow",
      c: "Red",
      d: "Green",
    },
    correctS: "c",
    correctA: "Red",
  },
  {
    question:
      'What does the Hawaiian word "wiki" mean, which gave the Internet encyclopedia Wikipedia its name?',
    answers: {
      a: "Simple",
      b: "Quick",
      c: "Learned",
      d: "Small",
    },
    correctS: "b",
    correctA: "Quick",
  },
  {
    question: "Which country does not cross the equator?",
    answers: {
      a: "Kenya",
      b: "Panama",
      c: "Brazil",
      d: "Indonesia",
    },
    correctS: "b",
    correctA: "Panama",
  },
  {
    question: "How many seas surround the Balkan Peninsula?",
    answers: {
      a: "3",
      b: "4",
      c: "5",
      d: "6",
    },
    correctS: "d",
    correctA: "6",
  },
  {
    question: "Who was the first to win the Nobel Prize for Literature?",
    answers: {
      a: "Poet",
      b: "Playwright",
      c: "Novelist",
      d: "Essayist",
    },
    correctS: "a",
    correctA: "Poet",
  },
  {
    question: "How many countries are part of Great Britain?",
    answers: {
      a: "1",
      b: "3",
      c: "4",
      d: "6",
    },
    correctS: "c",
    correctA: "4",
  },
  {
    question: "What ingredient do popsicles and sausages have in common?",
    answers: {
      a: "Sugar",
      b: "Chocolate",
      c: "Milk",
      d: "All answers are correct",
    },
    correctS: "d",
    correctA: "All answers are correct",
  },
  {
    question: "Which country has the highest mountain in the British Isles?",
    answers: {
      a: "England",
      b: "Scotland",
      c: "Wales",
      d: "Sudan",
    },
    correctS: "b",
    correctA: "Scotland",
  },
  {
    question:
      "This is the country where the annual Eurovision Song Contest was held for the first time in 1956?",
    answers: {
      a: "Switzerland",
      b: "France",
      c: "Great Britain",
      d: "Italy",
    },
    correctS: "a",
    correctA: "Switzerland",
  },
  {
    question: 'How many percent of a sloth"s life are spent sleeping?',
    answers: {
      a: "70%",
      b: "75%",
      c: "80%",
      d: "85%",
    },
    correctS: "b",
    correctA: "75%",
  },
  {
    question: "What vitamin is not in the melon?",
    answers: {
      a: "A",
      b: "C",
      c: "M",
      d: "P",
    },
    correctS: "c",
    correctA: "M",
  },
  {
    question: "What metal is necessarily present in amalgam?",
    answers: {
      a: "mercury",
      b: "lead",
      c: "silver",
      d: "copper",
    },
    correctS: "a",
    correctA: "mercury",
  },
  {
    question:
      "How much should you turn the dial of a clock when you are in England to know the time in India?",
    answers: {
      a: "None",
      b: "90",
      c: "180",
      d: "270",
    },
    correctS: "c",
    correctA: "180",
  },
]

// export default Questions;
